import React, { useState } from 'react';
import { MessageCircle, Send, Users, Image } from 'lucide-react';

const SendWhatsapp = () => {
  const [formData, setFormData] = useState({
    recipients: 'all',
    course: '',
    message: '',
    media: null
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('WhatsApp data:', formData);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Send WhatsApp Messages</h1>
        <p className="text-sm text-gray-500 mt-1">Send WhatsApp messages to students, staff, and suppliers</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Main Form */}
        <div className="lg:col-span-2">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Recipients Selection */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Users className="inline h-4 w-4 mr-2" />
                  Select Recipients
                </label>
                <select
                  value={formData.recipients}
                  onChange={(e) => setFormData({ ...formData, recipients: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                >
                  <option value="all">All Students</option>
                  <option value="course">By Course</option>
                  <option value="semester">By Semester</option>
                  <option value="section">By Section</option>
                  <option value="staff">All Staff</option>
                  <option value="suppliers">All Suppliers</option>
                  <option value="custom">Custom Selection</option>
                </select>
              </div>

              {/* Conditional Filters */}
              {formData.recipients === 'course' && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Select Course</label>
                  <select
                    value={formData.course}
                    onChange={(e) => setFormData({ ...formData, course: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  >
                    <option value="">Choose a course</option>
                    <option value="btech">B.Tech</option>
                    <option value="mtech">M.Tech</option>
                    <option value="bba">BBA</option>
                    <option value="mba">MBA</option>
                  </select>
                </div>
              )}

              {/* Message */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <MessageCircle className="inline h-4 w-4 mr-2" />
                  WhatsApp Message
                </label>
                <textarea
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  placeholder="Type your WhatsApp message here...\n\nYou can use emojis and formatting:\n*bold* _italic_ ~strikethrough~"
                  rows="8"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  required
                />
              </div>

              {/* Media Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Image className="inline h-4 w-4 mr-2" />
                  Media Attachment (Optional)
                </label>
                <input
                  type="file"
                  accept="image/*,video/*,application/pdf"
                  onChange={(e) => setFormData({ ...formData, media: e.target.files[0] })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
                <p className="text-xs text-gray-500 mt-1">Supported: Images, Videos, PDF (Max 16MB)</p>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-4">
                <button
                  type="submit"
                  className="flex items-center gap-2 bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors"
                >
                  <Send className="h-4 w-4" />
                  Send WhatsApp
                </button>
                <button
                  type="button"
                  className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Save as Template
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Info Panel */}
        <div className="space-y-4">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h3 className="font-semibold text-green-900 mb-2">WhatsApp Tips</h3>
            <ul className="text-sm text-green-800 space-y-2">
              <li>• Use *bold* for emphasis</li>
              <li>• Add emojis for engagement</li>
              <li>• Keep messages conversational</li>
              <li>• Include clear call-to-action</li>
            </ul>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <h3 className="font-semibold text-gray-900 mb-2">Message Statistics</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">Total Recipients:</span>
                <span className="font-semibold">50</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Sent Today:</span>
                <span className="font-semibold">0</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Delivery Rate:</span>
                <span className="font-semibold text-green-600">95%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendWhatsapp;